import axios from 'axios'
import type { ApiPayloadPaginated, ApiDataPaginated, GetItemPayload } from '@/types/api'
import type {Order, OrderPayload, SendOrderPayload, UpdateOrderPayload} from '@/types/order'

const BASE_PATH = '/orders'

const getOrdersListApiCall = async (
  abortController?: AbortController,
  params?: ApiPayloadPaginated,
): Promise<ApiDataPaginated<Order[]>> => {
  const { data } = await axios.get(BASE_PATH, { signal: abortController?.signal, params })

  return data.data
}

const getOrderItemApiCall = async (
  abortController?: AbortController,
  params?: GetItemPayload,
): Promise<Order> => {
  const { data } = await axios.get(`${BASE_PATH}/${params?.id}`, {
    signal: abortController?.signal,
  })

  return data.data
}

const createOrderItemApiCall = async (
  abortController?: AbortController,
  params?: OrderPayload,
): Promise<Order> => {
  const { data } = await axios.post(
    BASE_PATH,
    { ...params },
    {
      signal: abortController?.signal,
    },
  )

  return data.data
}

const updateOrderItemApiCall = async (
  abortController?: AbortController,
  params?: UpdateOrderPayload,
): Promise<Order> => {
  const { data } = await axios.post(`${BASE_PATH}/${params?.id}`, params?.data, {
    signal: abortController?.signal,
  })

  return data.data
}

const sendSupplierOfferApiCall = async (
  abortController?: AbortController,
  params?: SendOrderPayload,
): Promise<Order> => {
  const { data } = await axios.post(`${BASE_PATH}/${params?.id}/send-supplier-offer`, params?.data, {
    signal: abortController?.signal,
  })

  return data.data
}

export { getOrdersListApiCall, getOrderItemApiCall, createOrderItemApiCall, updateOrderItemApiCall, sendSupplierOfferApiCall }
